function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M21.4 12.95l-4.51 2.26-3.19-3.19 3.22-3.22 4.48 2.25c.79.39.79 1.51 0 1.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.92 8.8l-3.22 3.22-9.67-9.67L16.92 8.8z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M13.7 12.02L4.12 21.6l-.57.29c-.72.35-1.55-.16-1.55-.96V3.07c0-.8.83-1.31 1.55-.96l.48.24 9.67 9.67z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.89 15.21L4.12 21.6l9.58-9.58 3.19 3.19z"
})));